// extracted by mini-css-extract-plugin
module.exports = {"containerUser":"user_containerUser__1HUXu","title":"user_title__1Rj51","graphic":"user_graphic__1cDTw"};